<div class="result" (click)="openArticle()" [ngClass]="article().source">
  <div class="result--title">{{ article().title }}</div>
  <div class="result--snippet">
    {{ article().body }}
  </div>
  <div class="result--source">
    <mat-icon class="result--source-icon">{{ icon() }}</mat-icon>
    <div class="result--source-text">{{ article().source }}</div>
  </div>
</div>
